import { render, staticRenderFns } from "./ScopedUserItem.vue?vue&type=template&id=d2f820d6&"
import script from "./ScopedUserItem.vue?vue&type=script&lang=js&"
export * from "./ScopedUserItem.vue?vue&type=script&lang=js&"
import style0 from "./ScopedUserItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItemAvatar,VListItemContent})
